// extracted by mini-css-extract-plugin
module.exports = {"container":"app-loader_container__7DW_n","isShow":"app-loader_isShow__hqhNX","spinner":"app-loader_spinner__GjpxZ"};